module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_data04-5d4abb641f91885450aa100eed4335a9.png";